module.exports = __webpack_public_path__ + "img/alvin-pro.cd9e5850.jpg";